import {SET_CURRENT_RESTAURANT, START} from 'new-constants/app-state.constants';
import {SELECT_LOCATION_POPUP} from 'new-components/popups/select-location/SelectLocation';
import {INITIAL_POPUP} from 'new-components/popups/initial/Initial';
import {DELIVERY_ADDRESS_POPUP} from 'new-components/popups/delivery-address/DeliveryAddress';
import {ZIP_EDIT_POPUP} from 'new-components/popups/zip-edit/ZipEdit';
import {CAUTH_CLEAR_CUSTOMER_DATA, DONE_CAUTH_CLEAR_CUSTOMER_DATA, SET_CURRENT_RESTAURANT_FROM_CART} from "../constants/app-state.constants";
import {CART_DELIVERY_ADDRESS_POPUP} from "../components/popups/delivery-address/DeliveryAddress";
import {CART_ZIP_EDIT_POPUP} from "../components/popups/zip-edit/ZipEdit";
import {CART_SELECT_LOCATION_POPUP} from "../components/popups/select-location/SelectLocation";
import {getStartupParams} from "../helpers/startup-params.helper";
import {LoadingStyle} from "../reducers/loading.reducer.types";
import {AdyenReturnModes} from 'new-constants/common.constants';
import {MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP} from 'new-components/popups/error-message/ErrorMessage'
import { MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP} from "../components/popups/error-message/ErrorMessage";
import {trackEvent} from "../helpers/tracking.helpers";
import {CAUTH_CLEAR_CUSTOMER_DATA_POPUP} from "../constants/popup.constants";

function getAdyenReturnErrorPopup(adyenReturnMode, currentCustomer) {
	if (
		adyenReturnMode === AdyenReturnModes.STATE_IS_NULL &&
		!currentCustomer?.phone //!loggedIn
	) {
		return MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP;
	} else if (adyenReturnMode === AdyenReturnModes.URL_IS_NULL) {
		return MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP;
	}
	
	return null;
}

export const start = (currentAppId, adyenReturnMode, currentCustomer) => {
	const returnFromAdyen = getStartupParams().returnFromAdyen
		? {
			orderId: getStartupParams().orderId,
			restaurantId: getStartupParams().restaurantId,
			orderType: getStartupParams().orderType,
			redirectResult: getStartupParams().redirectResult,
			paymentType: getStartupParams().paymentType,
			secret: getStartupParams().secret,
		}
		: null;
	
	return {
		type: START,
		currentAppId,
		timestamp: Date.now(),
		showLoading: returnFromAdyen && (adyenReturnMode === AdyenReturnModes.URL_STATE_MATCH || adyenReturnMode === AdyenReturnModes.URL_STATE_MISMATCH)
			? LoadingStyle.TRANSPARENT : null,
		showPopup: getAdyenReturnErrorPopup(adyenReturnMode, currentCustomer),
		returnFromAdyen,
		adyenUrlOrderId: getStartupParams().orderId,
		adyenReturnMode,
		isCustomerLoggedIn: !!currentCustomer?.phone,
	}
};

export const setCurrentRestaurant = restaurantId => {
	trackEvent({
		event: 'Select Venue',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: SET_CURRENT_RESTAURANT,
		restaurantId,
		hidePopups: [SELECT_LOCATION_POPUP, INITIAL_POPUP, DELIVERY_ADDRESS_POPUP, ZIP_EDIT_POPUP],
	};
};

export const setCurrentRestaurantFromCart = restaurantId => {
	trackEvent({
		event: 'Select Venue From Cart',
		properties: {
			'Venue Id': restaurantId
		}
	});
	return {
		type: SET_CURRENT_RESTAURANT_FROM_CART,
		restaurantId,
		hidePopups: [CART_SELECT_LOCATION_POPUP, CART_DELIVERY_ADDRESS_POPUP, CART_ZIP_EDIT_POPUP],
	};
}

export const cauthClearCustomerData = (appId, restaurantIds) => {
	trackEvent({
		event: 'Cauth Clear Customer Data',
	});
	return {
		type: CAUTH_CLEAR_CUSTOMER_DATA,
		showPopup: CAUTH_CLEAR_CUSTOMER_DATA_POPUP,
		appId,
		restaurantIds,
	};
}

export const doneCauthClearCustomerData = () => {
	return {
		type: DONE_CAUTH_CLEAR_CUSTOMER_DATA,
		hidePopups: [CAUTH_CLEAR_CUSTOMER_DATA_POPUP],
		showPopup: INITIAL_POPUP,
	}
}
